import { render } from "./ImageCropperModal.vue?vue&type=template&id=065133fc&scoped=true"
import script from "./ImageCropperModal.vue?vue&type=script&lang=js"
export * from "./ImageCropperModal.vue?vue&type=script&lang=js"

import "./ImageCropperModal.vue?vue&type=style&index=0&id=065133fc&scoped=true&lang=css"

import exportComponent from "/home/cm/project/golinker/admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-065133fc"]])

export default __exports__